import className from 'classnames/bind';

import styles from './VimeoEmbed.module.scss';
const cx = className.bind(styles);

// TODO: prototype (youtube privacy compliance, option A). Stand-in Vimeo
// player rendered wherever a YouTube player would appear when ?v=vimeo is on
// the URL. The site's videos are not hosted on Vimeo, so every player shows
// one public demo video; a real migration would add a vimeo_video_id ACF
// field next to each youtube_video_id and map per video.
// dnt=1 (Do Not Track) is the point of the exercise: Vimeo sets no cookies
// and sends no tracking beacons in this configuration.
export const VIMEO_DEMO_ID = '76979871';

export const buildVimeoSrc = ({ autoplay = true, muted = false }: { autoplay?: boolean; muted?: boolean } = {}) =>
  `https://player.vimeo.com/video/${VIMEO_DEMO_ID}?dnt=1&autoplay=${autoplay ? 1 : 0}&muted=${muted ? 1 : 0}&byline=0&portrait=0`;

type VimeoEmbedProps = {
  autoplay?: boolean;
  soundEnabled?: boolean;
  className?: string;
  title?: string;
};

const VimeoEmbed = ({ autoplay = true, soundEnabled, className, title }: VimeoEmbedProps) => (
  <div className={cx(['vimeo-embed', className])}>
    <iframe
      src={buildVimeoSrc({ autoplay, muted: soundEnabled === false })}
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
      title={title || 'Video'}
    />
  </div>
);

export default VimeoEmbed;
